type ImpressionKey = string

const cachedImpressionKeys: ImpressionKey[] = []

function getCachedImpressionKeys(): ImpressionKey[] {
  return cachedImpressionKeys
}

function addCachedImpression(impressionString: ImpressionKey): number {
  return cachedImpressionKeys.push(impressionString)
}

export { addCachedImpression, getCachedImpressionKeys }
